import { useAuth } from '@/contexts/AuthContext';

/**
 * Whether the current user's role (in the active workgroup) grants `action`
 * on `module`. Backed by AuthContext's `permissions` array, itself sourced
 * from GET /auth/login-info (see AccessControlService.getEffectivePermissions
 * on the backend) and refetched whenever the active workgroup changes.
 *
 * Kept as its own hook (rather than inlined at call sites) so that a future
 * Entitlements check can be ANDed in later without touching every call site:
 *
 *   useCanAccess(module, action) {
 *     return useHasPermission(module, action) && useEntitlement(module, action);
 *   }
 */
export function useHasPermission(module: string, action: string): boolean {
  const { hasPermission } = useAuth();
  return hasPermission(module, action);
}

export default useHasPermission;
